import { Selections } from "../../../services/api";
import { SelectionCover, getSelectionCovers } from "./SelectionCover";

interface TitledCoverProps {
  selection: Selections;
  /** Largest size it is shown at, in px (image resolution). The cover fills its parent's width. */
  size: number;
  variant?: "large" | "small";
}

// A selection cover with its title over the bottom on a dark fade, and the Mattdigging logo
// in the top-right corner. Same look as the mobile app ("This week", the Available grid, a selection).
const TitledCover = ({ selection, size, variant = "small" }: TitledCoverProps) => (
  <div className={`titledCover titledCover--${variant}`}>
    <SelectionCover coverUrls={getSelectionCovers(selection)} savedCover={selection.cover_url} size={size} seed={selection.id} fluid />
    <img className="titledCover__logo" src="/svg/logo-color.svg" alt="" aria-hidden="true" />
    <div className="titledCover__fade">
      <span className="titledCover__title">{selection.title}</span>
    </div>
  </div>
);

export default TitledCover;
